import classNames from "classnames/bind";
import React from "react";
import { Info } from "../../Info";
import styles from "./FormLabel.module.scss";
import { FormLabelProps } from "./types";

const cx = classNames.bind(styles);

/**
 * Component for the label component of an input in a form
 * @deprecated use `InputWithLabels` instead
 */
const FormLabel = ({
  label,
  isRequired,
  isDisabled,
  description,
  shouldShowDescriptionInTooltip = true,
  isOptionalTextShown = true,
  inputId,
  id,
  ...props
}: FormLabelProps) => {
  if (!label && !isRequired) return null;

  return (
    <div
      className={cx("labelContainer")}
      {...props}
    >
      <label
        htmlFor={inputId}
        className={cx("label", { "label--disabled": isDisabled })}
        id={id}
      >
        {label}
      </label>

      {description ? (
        <div className={cx("infoContainer")}>
          {shouldShowDescriptionInTooltip ? (
            <Info content={description} />
          ) : (
            <div className={cx("description")}>{description}</div>
          )}
        </div>
      ) : null}

      {!isRequired && isOptionalTextShown && (
        <div
          className={cx("label--required", { "label--disabled": isDisabled })}
        >
          Optional
        </div>
      )}
    </div>
  );
};

export default FormLabel;
